'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');

/**
 * SVG Arrow for the Tooltip component
 *
 * @scope Web
 */ const RoundedArrow = ({ width = 12, height = 8, className, ...props })=>{
    return /*#__PURE__*/ jsxRuntime.jsx("svg", {
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        className: className,
        ...props,
        children: /*#__PURE__*/ jsxRuntime.jsx("path", {
            d: "M0,0 H30 L16.5,8 Q15,10 13.5,8 Z"
        })
    });
};

exports.RoundedArrow = RoundedArrow;
//# sourceMappingURL=RoundedArrow.cjs.map
